__turbopack_context__.v({
  "avatarFallback": "JobCardLight-module__YujlNW__avatarFallback",
  "avatarImage": "JobCardLight-module__YujlNW__avatarImage",
  "avatarPanel": "JobCardLight-module__YujlNW__avatarPanel",
  "avatarWrapper": "JobCardLight-module__YujlNW__avatarWrapper",
  "bottom": "JobCardLight-module__YujlNW__bottom",
  "card": "JobCardLight-module__YujlNW__card",
  "cta": "JobCardLight-module__YujlNW__cta",
  "ctaIcon": "JobCardLight-module__YujlNW__ctaIcon",
  "headings": "JobCardLight-module__YujlNW__headings",
  "highlights": "JobCardLight-module__YujlNW__highlights",
  "name": "JobCardLight-module__YujlNW__name",
  "recruiterLogo": "JobCardLight-module__YujlNW__recruiterLogo",
  "recruiterLogoPlaceholder": "JobCardLight-module__YujlNW__recruiterLogoPlaceholder",
  "root": "JobCardLight-module__YujlNW__root",
  "skill": "JobCardLight-module__YujlNW__skill",
  "skillEmoji": "JobCardLight-module__YujlNW__skillEmoji",
  "skillsLabel": "JobCardLight-module__YujlNW__skillsLabel",
  "skillsList": "JobCardLight-module__YujlNW__skillsList",
  "skillsPanel": "JobCardLight-module__YujlNW__skillsPanel",
  "title": "JobCardLight-module__YujlNW__title",
  "top": "JobCardLight-module__YujlNW__top",
});
